var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.openPopup
    ? _c("div", { staticClass: "generic-popup-container" }, [
        _c(
          "div",
          { staticClass: "generic-popup-background" },
          [
            _c(_vm.componentToRender, {
              tag: "component",
              on: { closeGenericPopup: _vm.closeGenericPopup }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }